import React, { useEffect, useState } from "react";
import HeadingSubHeading from "../../../../components/ViewHeading/HeadingSubHeading";
import { Button, Card, Col, DatePicker, Dropdown, Flex, Form, List, Modal, Radio, Row, Select, Space, Typography } from "antd";
import { MasterConfigs } from "../../../../interfaces/entity";
import './../index.scss';
import FormSetup from "../../../../components/Forms/FormSetup";
import { useDispatch } from "react-redux";
import { deleteRow, getData } from "../../../../actions/apiCall";
import { MoreOutlined } from '@ant-design/icons'
import Configuration from "./Configurations";
import ProfileCard from "../../../../components/ContactInfo/ProfileCard";
const { Title, Text } = Typography

const LeavePlans = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [value, setValue] = useState(null);
    const [data, setData] = useState([])
    const [selectedPlan, setSelectedPlan] = useState(null)
    const [plainId, setPlainId] = useState(null)
    const dispatch = useDispatch();

    useEffect(() => {
        getAllLeavePlans();
    }, [])

    useEffect(() => {
        if (plainId && selectedPlan?._id == plainId) {
            setValue(selectedPlan?.leaveCalendar)
            setIsOpen(true)
        }
    }, [plainId])

    const getAllLeavePlans = async () => {
        const resData = await dispatch(getData('/leave-plan'))
        if (resData.code == 200) {
            if (resData.data.length > 0 && !selectedPlan) {
                setSelectedPlan(resData.data[0])
            }
            setData(resData.data)
        }
    }

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

    const FromItems = () => {
        return <Form.Item
            label="Leave calendar year under this plan"
            name="leaveCalendar"
            rules={[{ required: true, message: 'Please select a leave calendar year' }]}
        >
            <Radio.Group value={value} onChange={(e) => setValue(e.target.value)}>
                <Space direction="vertical" >
                    <Radio value={'startsFromPerticularMonth'}>
                        <Space direction="horizontal" >
                            Starts from a particular month
                            <Form.Item name="selectedMonth" noStyle rules={[{ required: value == 'startsFromPerticularMonth', message: 'Date is required' }]}>
                                <Select style={{ width: 120 }} placeholder="Select Month" disabled={value !== 'startsFromPerticularMonth'}>
                                    {months.map((item, index) => <Select.Option key={index} value={item}>{item}</Select.Option>)}
                                </Select>
                            </Form.Item>
                        </Space>
                    </Radio>
                    <Radio value={'fromEmployeeJoiningDate'}>
                        <Space direction="vertical" size={[0, 0]}>
                            From employee joining date
                            <Text type="secondary">The calendar year for the employee will start from the date of their joining and end on their work anniversary.</Text>
                        </Space>
                    </Radio>
                </Space>
            </Radio.Group>
        </Form.Item >
    }

    const onClickPlan = (item) => {
        setSelectedPlan(item)
    }

    const formConfig: MasterConfigs = {
        modalTitle: () => 'Leave Plan',
        api: () => '/leave-plan',
        combo: [],
        getFormColumns: () => [
            {
                label: 'Leave Plan Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Leave plan name' }]
            },
            {
                span: 16,
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 12,
            },
            {
                formItem: () => <FromItems />,
                span: 24
            },
            {
                label: 'Leave Policy Explanation',
                name: 'leave_policy',
                type: 'checkboxGroup',
                span: 24,
                children: [{
                    name: 'Show leave policy explanation generated by Accelgrowth',
                    value: 'show_leave_policy'
                }, {
                    name: 'Upload custom leave policy document',
                    value: 'upload_custom_leave_policy'
                }
                ]
            }
        ],
        onRefresh: () => getAllLeavePlans()
    }

    const onClose = () => {
        setPlainId(null)
        setValue(null)
        setIsOpen(false)
    }

    const onDelete = async (id) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this leave plan?',
            content: 'Once deleted, you will not be able to recover this leave plan!',
            okText: 'Yes',
            cancelText: 'No',
            onOk: async () => {
                const resData = await dispatch(deleteRow(`/leave-plan/${id}`))
                if (resData.code == 200) {
                    onClose();
                    setSelectedPlan(null)
                    getAllLeavePlans();
                }
            }
        })
    }

    const renderListItem = (item) => {
        return <List.Item key={item.name} className={(selectedPlan?._id == item?._id ? 'active_list' : '') + " plan-item"} onClick={() => onClickPlan(item)}>
            <Space direction="vertical" style={{ width: '100%' }}>
                <Title level={5}>{item?.name}</Title>
                <Text>{new Date(item?.createdAt).toDateString()}</Text>
            </Space>
        </List.Item >
    }

    return <>
        <FormSetup config={formConfig} open={isOpen} onClose={onClose} isModal={true} id={plainId} />
        <Flex justify="space-between">
            <HeadingSubHeading
                title="Leave Plans"
                subTitle="Manage leave plans for your organization"
            />
            <Button type="primary" onClick={() => setIsOpen(true)}>Add Leave Plan</Button>
        </Flex>
        <Row gutter={[16, 16]}>
            <Col span={4}>
                <Card
                    title="Card Title"
                    className="custom-card"
                >
                    <List
                        bordered={false}
                        dataSource={data}
                        size="small"
                        renderItem={item => (renderListItem(item))}
                    />
                </Card>
            </Col>
            <Col span={20}>
                <Card>
                    <Space direction="vertical" style={{ width: '100%' }} size={[10, 10]}>
                        <Flex justify="space-between">
                            <Title level={5}>{selectedPlan?.name}</Title>
                            <Dropdown menu={{
                                items: [{
                                    key: '1',
                                    label: 'Edit',
                                },
                                {
                                    key: '2',
                                    label: 'Delete',
                                }
                                ],
                                onClick: (e) => {
                                    if (e.key == '1') {
                                        setPlainId(selectedPlan?._id)
                                    } else {
                                        onDelete(selectedPlan?._id)
                                    }
                                }
                            }}>
                                <Button icon={<MoreOutlined />} type="text" />
                            </Dropdown>
                        </Flex>
                        {selectedPlan && <Configuration key={selectedPlan._id} plainId={selectedPlan?._id} />}
                    </Space>
                </Card>
            </Col>
        </Row>
    </>
};

export default LeavePlans;